<script>
//import store from '@/store';
import { calendarIcon, crossIcon, refreshIcon } from '@/utils/proposalIcons';

export default {
    name: "ProjectFilter",
    props: {
        showFilters: { type: Boolean, default: false },
        selectedSegment: { type: [String, Number], default: 'All Segments' },
        dateFrom: { type: String, default: '' },
        dateTo: { type: String, default: '' },
    },
    data() {
        return {
            calendarIcon, crossIcon, refreshIcon
        };
    },
    computed: {
        marketSegments() {
            return this.$store.state.marketSegments.data || [];
        },
        marketSegmentOptions() {
            return [
                { value: 'All Segments', label: 'All Segments' },
                ...this.marketSegments.map((seg) => ({ label: seg.marketSegmentName, value: seg.marketSegmentId })),
            ];
        },
        selectedSegmentName() {
            if (this.selectedSegment === 'All Segments') return 'All Segments';
            const segment = this.marketSegments.find(s => s.marketSegmentId == this.selectedSegment);
            return segment ? segment.marketSegmentName : this.selectedSegment;
        },
    },
    methods: {
        handleApply() {
            this.$emit('apply');
        },
        handleReset() {
            this.$emit('reset');
        },
        handleClose() {
            this.$emit('close');
        },
    }
};
</script>

<template>
    <div>
        <div v-if="showFilters" class="filters-panel">
            <div class="filter-group">
                <label>Market Segment</label>
                <select :value="selectedSegment" @change="$emit('update:selectedSegment', $event.target.value)"
                    class="filter-select">
                    <option v-for="seg in marketSegmentOptions" :key="seg.value" :value="seg.value">
                        {{ seg.label }}
                    </option>
                </select>
            </div>
            <div class="filter-group">
                <label>Completion Date</label>
                <div class="date-range-wrapper">
                    <div class="date-inputs">
                        <div class="date-cont">
                            <button type="button" class="calendar-icon-btn" @click="$refs.fromDateInput.showPicker()">
                                <span v-html="calendarIcon" />
                            </button>
                            <input type="date" :value="dateFrom" @input="$emit('update:dateFrom', $event.target.value)"
                                :max="dateTo" class="date-input" placeholder="From" ref="fromDateInput"></input>
                        </div>
                        <span class="saperator">|</span>
                        <div class="date-cont">
                            <button type="button" class="calendar-icon-btn" @click="$refs.toDateInput.showPicker()"
                                :disabled="!dateFrom">
                                <span v-html="calendarIcon" />
                            </button>
                            <input type="date" :value="dateTo" @input="$emit('update:dateTo', $event.target.value)"
                                :disabled="!dateFrom" :min="dateFrom" class="date-input" placeholder="To"
                                ref="toDateInput"></input>
                        </div>
                    </div>
                </div>
            </div>
            <div class="btn-group">
                <button class="apply-filters-btn" @click="handleApply">
                    Apply
                </button>
                <button class="reset-filters-btn" @click="handleReset">
                    <span v-html="refreshIcon" />
                </button>
                <button class="close-filters-btn" @click="handleClose">
                    <span v-html="crossIcon" />
                </button>
            </div>
        </div>

        <!-- Active Filter Pills -->
        <div v-if="!showFilters && (selectedSegment !== 'All Segments' || (dateFrom && dateTo))"
            class="active-filters-pills">
            <div v-if="selectedSegment !== 'All Segments'" class="filter-pill">
                <span>{{ selectedSegmentName }}</span>
                <button class="remove-pill"
                    @click.stop="$emit('update:selectedSegment', 'All Segments'); $emit('apply')">&times;</button>
            </div>
            <div v-if="dateFrom && dateTo" class="filter-pill">
                <span>{{ dateFrom }} to {{ dateTo }}</span>
                <button class="remove-pill"
                    @click.stop="$emit('update:dateFrom', ''); $emit('update:dateTo', ''); $emit('apply')">&times;</button>
            </div>
        </div>
    </div>
</template>


<style scoped lang="scss">
.filters-panel {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    padding: 5px;
    border: 1px solid #eee;
    border-radius: 4px;
    padding-top: 24px;
    margin-top: 8px;
    align-items: flex-end;

    .filter-group {
        display: flex;
        flex-direction: column;
        flex: 1;

        label {
            font-size: 9px;
            font-weight: 600;
            margin-bottom: 2px;
            text-transform: uppercase;
        }

        .filter-select {
            width: 100%;
            padding: 4px 6px;
            height: 30px;
            border: 1px solid #cbd5e1;
            border-radius: 4px;
            font-size: 12px;
            outline: none;
            background: #fff;
            min-width: 100px;

            &:focus {
                border-color: #4a90e2;
            }
        }

        .date-range-wrapper {
            .date-inputs {
                display: flex;
                align-items: center;
                justify-content: space-between;
                flex: 1;
                height: 30px;
                border: 1px solid #cbd5e1;
                border-radius: 4px;
                font-size: 12px;
                outline: none;
                background: #fff;
                padding: 0px 5px;

                .saperator {
                    color: #cbd5e1;
                    padding: 0px 10px;
                }

                .date-cont {
                    display: flex;
                    align-items: center;

                    .date-input {
                        cursor: pointer;
                        width: 70px;
                        border: none;
                        outline: none;
                        padding: 0px;

                        &:focus {
                            border-color: #4a90e2;
                        }

                        &:disabled {
                            cursor: default;
                            color: #999;
                            background: transparent;
                        }

                        &::-webkit-calendar-picker-indicator {
                            display: none;
                            -webkit-appearance: none;
                        }

                        &::-moz-calendar-picker-indicator {
                            display: none;
                        }
                    }

                    .calendar-icon-btn {
                        background: none;
                        border: none;
                        cursor: pointer;
                        padding: 0px;
                        padding-right: 2px;
                        padding-bottom: 2px;

                        &:disabled {
                            cursor: default;
                            color: #999;
                        }

                        &:hover {
                            color: #4a90e2;

                            &:disabled {
                                color: #999;
                            }
                        }
                    }
                }
            }
        }
    }

    .btn-group {
        position: absolute;
        right: 0;
        top: 0;
        display: flex;
        gap: 2px;
        align-items: center;
        margin: 5px;

        button {
            display: flex;
            align-items: center;
            justify-content: center;
            background: none;
            border-radius: 4px;
            cursor: pointer;
            padding: 0px 2px;
            height: 20px;
            font-size: 12px;
        }

        .apply-filters-btn {
            color: #4a90e2;
            border: 1px solid #4a90e2;
            padding: 5px 10px;

            &:hover {
                background: #e6f3ff;
                color: #4a90e2;
                border-color: #4a90e2;
            }
        }

        .reset-filters-btn {
            color: #4a90e2;
            border: 1px solid #4a90e2;

            &:hover {
                background: #e6f3ff;
                color: #4a90e2;
                border-color: #4a90e2;
            }
        }

        .close-filters-btn {
            color: #ef4444;
            border: 1px solid #fecaca;

            &:hover {
                background: #fef2f2;
                border-color: #ef4444;
            }
        }
    }
}

.active-filters-pills {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    margin-top: 8px;
    gap: 4px;

    .filter-pill {
        display: flex;
        align-items: center;
        font-size: 10px;
        padding: 4px 8px;
        background: #e6f3ff;
        border-radius: 4px;

        span {
            color: #4a90e2;
            font-weight: 500;
        }

        .remove-pill {
            background: none;
            border: none;
            color: #4a90e2;
            cursor: pointer;
            font-size: 14px;
            padding: 0;
            margin-left: 6px;
            line-height: 1;

            &:hover {
                color: #ef4444;
            }
        }
    }
}
</style>
